import "core-js/modules/es6.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import moment from 'moment';
var DATE_FORMAT = 'YYYY/MM/DD';
export default {
  name: 'FibDateTimePicker',
  props: {
    daysBack: {
      type: Number,
      default: null
    },
    daysForward: {
      type: Number,
      default: null
    },
    isPreview: {
      type: Boolean,
      default: true
    },
    value: {
      type: [Object],
      required: true
    }
  },
  data: function data(self) {
    return {
      availableDates: function availableDates(date) {
        var day = moment(date, DATE_FORMAT);
        var valid = true; // Disallow dates before the allowable window

        if (typeof self.daysBack === 'number') {
          valid = valid && day.isAfter(moment().subtract(self.daysBack, 'days').startOf('day'));
        } // Disallow dates after the allowable window


        if (typeof self.daysForward === 'number') {
          valid = valid && day.isBefore(moment().add(self.daysForward, 'days').endOf('day'));
        }

        return valid;
      },
      openModal: false,
      selected: '',
      selectedDate: moment(),
      selectedTime: {
        hour: moment().format('hh'),
        min: '00',
        meridian: moment().format('a')
      },
      today: moment(),
      yesterday: moment().subtract(1, 'd')
    };
  },
  computed: {
    dateOptions: function dateOptions() {
      return [{
        id: 1,
        label: this.$t('checkIn.aboutVisit.yesterday'),
        val: this.$t('checkIn.aboutVisit.yesterday')
      }, {
        id: 2,
        label: this.$t('checkIn.aboutVisit.today'),
        val: this.$t('checkIn.aboutVisit.today')
      }, {
        id: 3,
        label: this.$t('checkIn.aboutVisit.choose'),
        val: this.$t('checkIn.aboutVisit.choose'),
        icon: 'calendar_today',
        leftLabel: true
      }];
    },
    theme: function theme() {
      return this.$store.getters['theme/theme'];
    }
  },
  watch: {
    selected: function selected(newValue) {
      this.setDate(newValue);
    },
    selectedDate: function selectedDate(newValue) {
      if (typeof newValue === 'string') {
        this.selectedDate = moment(newValue, DATE_FORMAT);
      }

      if (this.selectedDate.isSame(this.today, 'd')) {
        this.selected = this.$t('checkIn.aboutVisit.today');
      }

      if (this.selectedDate.isSame(this.yesterday, 'd')) {
        this.selected = this.$t('checkIn.aboutVisit.yesterday');
      }

      this.setTime();
      this.closeModal();
    },
    selectedTime: function selectedTime() {
      this.setTime();
    },
    value: function value(newValue) {
      this.selectedDate = newValue;
    }
  },
  mounted: function mounted() {
    var hour = this.value.hour();
    this.selectedTime = {
      hour: this.leadingZero(hour > 12 ? hour - 12 : hour),
      min: this.leadingZero(this.value.minutes()),
      meridian: hour >= 12 ? this.$t('checkIn.aboutVisit.pm') : this.$t('checkIn.aboutVisit.am')
    };
    this.selected = this.$t('checkIn.aboutVisit.today');
  },
  methods: {
    setDate: function setDate(newValue) {
      switch (newValue) {
        case this.$t('checkIn.aboutVisit.today'):
          this.selectedDate = this.today;
          break;

        case this.$t('checkIn.aboutVisit.yesterday'):
          this.selectedDate = this.yesterday;
          break;

        case this.$t('checkIn.aboutVisit.choose'):
          this.openModal = true;
          break;
      }
    },
    setTime: function setTime() {
      // selectedTime.meridian is translated rather than being a canonical form of the meridian
      // (e.g. am/pm) - so we need to convert it to that form so that moment can understand it.
      var meridian = this.selectedTime.meridian === this.$t('checkIn.aboutVisit.am') ? 'am' : 'pm';
      var time = moment(this.selectedTime.hour + ':' + this.selectedTime.min + ':00 ' + meridian, 'hh:m:ss a');
      this.selectedDate.hour(time.format('HH')).minute(time.format('mm')).second(0).millisecond(0);
      this.$emit('input', this.selectedDate);
      this.validate();
    },
    closeModal: function closeModal() {
      this.openModal = false;
    },
    handleSelectOptionClicked: function handleSelectOptionClicked(context) {
      if ((context === null || context === void 0 ? void 0 : context.val) === 'Choose') {
        this.openModal = true;
      }
    },
    leadingZero: function leadingZero(num) {
      if (num < 10) {
        return '0' + num;
      }

      return String(num);
    },
    validate: function validate() {
      var now = moment();
      var valid = this.selectedDate.isBefore(now);
      this.$emit('validation', valid);
    }
  }
};